import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8701550"
import script from "./assetStatus.js?vue&type=script&lang=js&external"
export * from "./assetStatus.js?vue&type=script&lang=js&external"
import style0 from "./assetStatus.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports